import React, { Fragment } from 'react';
import safeDivideHelper from '../../../../../Helpers/SafeDivideHelper';
import MobileDataTableCard from '../../../../../DataTables/MobileDataTableCard';
import AdvancedDataTable from '../../../../../DataTables/AdvancedDataTable';

export default function QuarterbacksProAdvancedRushingStatsTable(props) {
	return (
		<div>
			<div className="text-xl py-2">
				<h4>{props.title}</h4>
			</div>
			<div className="contents lg:hidden">
				<MobileDataTableCard
					data={props.data}
					style="text-gray-800 dark:text-dark-text border-b border-gray-300 dark:border-dark-border font-semibold"
					rowRenderer={(row) => {
						const labels = [
							{
								displayName: 'Category',
								apiName: 'category',
								alignment: 'left'
							},
							{
								displayName: 'Rush Attempts Per Game',
								apiName: 'pro_rush_attempts_per_game',
								alignment: 'left',
								helper_text: 'The average rush attempts per game.'
							},
							{
								displayName: 'Rushing Yards Per Game',
								apiName: 'pro_rushing_yards_per_game',
								alignment: 'left',
								helper_text: 'The average rushing yards per game.'
							},
							{
								displayName: 'Rushing TDs Per Game',
								apiName: 'pro_rushing_touchdowns_per_game',
								alignment: 'left',
								helper_text: 'The average rushing touchdowns per game.'
							},
							{
								displayName: 'Rush Attempts Per TD',
								apiName: 'pro_rush_attempts_per_touchdown',
								alignment: 'left',
								helper_text: 'The average rush attempts per touchdown.'
							},
							{
								displayName: 'Rushing Yards Per TD',
								apiName: 'pro_rushing_yards_per_touchdown',
								alignment: 'left',
								helper_text: 'The average rushing yards per touchdown.'
							}
						];
						return (
							<div
								key={`${row.first_name} ${row.last_name} - PlayersProfileStatsTable - MobileDataTableCard`}
								className="p-5 bg-white dark:bg-dark-card border-t border-gray-200 dark:border-dark-border text-gray-800 dark:text-dark-text"
							>
								<div className="flex flex-wrap">
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[1].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.pro_rush_attempts_per_game}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[2].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.pro_rushing_yards_per_game}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[3].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.pro_rushing_touchdowns_per_game}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[4].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.pro_rush_attempts_per_touchdown}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[5].displayName}
									</div>
									<div className="w-1/2">
										{row.pro_rushing_yards_per_touchdown}
									</div>
								</div>
							</div>
						);
					}}
				/>
			</div>
			<div className="hidden lg:contents">
				<AdvancedDataTable
					data={props.data}
					style="text-gray-800 dark:text-dark-text border-b border-gray-300 dark:border-dark-border font-semibold"
					columns={[
						{
							displayName: 'Category',
							apiName: 'category',
							alignment: 'left'
						},
						{
							displayName: 'Rush Attempts Per Game',
							apiName: 'pro_rush_attempts_per_game',
							alignment: 'left',
							helper_text: 'The average rush attempts per game.'
						},
						{
							displayName: 'Rushing Yards Per Game',
							apiName: 'pro_rushing_yards_per_game',
							alignment: 'left',
							helper_text: 'The average rushing yards per game.'
						},
						{
							displayName: 'Rushing Touchdowns Per Game',
							apiName: 'pro_rushing_touchdowns_per_game',
							alignment: 'left',
							helper_text: 'The average rushing touchdowns per game.'
						},
						{
							displayName: 'Rush Attempts Per Touchdown',
							apiName: 'pro_rush_attempts_per_touchdown',
							alignment: 'left',
							helper_text: 'The average rush attempts per touchdown.'
						},
						{
							displayName: 'Rushing Yards Per Touchdown',
							apiName: 'pro_rushing_yards_per_touchdown',
							alignment: 'left',
							helper_text: 'The average rushing yards per touchdown.'
						}
					]}
					rowRenderer={(row) => {
						return (
							<Fragment key={`${row.id} - ${row.position}`}>
								<tr
									key={`${row.id} - ${row.position} - 2025`}
									className="bg-white dark:bg-dark-card border-t border-gray-200 dark:border-dark-border text-gray-800 dark:text-dark-text"
								>
									<td className="pl-8 py-3 text-left sticky left-0 bg-white dark:bg-dark-card z-10 text-gray-800 dark:text-dark-text">
										2025
									</td>
									<td className="pl-8 py-3 text-left">
										{safeDivideHelper(
											row.current_year_pro_rush_attempts,
											row.current_year_pro_games_played
										)}
									</td>
									<td className="pl-8 py-3 text-left">
										{safeDivideHelper(
											row.current_year_pro_rushing_yards,
											row.current_year_pro_games_played
										)}
									</td>
									<td className="pl-8 py-3 text-left">
										{safeDivideHelper(
											row.current_year_pro_rushing_touchdowns,
											row.current_year_pro_games_played
										)}
									</td>
									<td className="pl-8 py-3 text-left">
										{safeDivideHelper(
											row.current_year_pro_rush_attempts,
											row.current_year_pro_rushing_touchdowns
										)}
									</td>
									<td className="pl-8 py-3 text-left">
										{safeDivideHelper(
											row.current_year_pro_rushing_yards,
											row.current_year_pro_rushing_touchdowns
										)}
									</td>
								</tr>
								<tr
									key={`${row.id} - ${row.position} - Career`}
									className="bg-white dark:bg-dark-card border-t border-gray-200 dark:border-dark-border text-gray-800 dark:text-dark-text"
								>
									<td className="pl-8 py-3 text-left sticky left-0 bg-white dark:bg-dark-card z-10 text-gray-800 dark:text-dark-text">
										Career
									</td>
									<td className="pl-8 py-3 text-left">
										{safeDivideHelper(
											row.pro_rush_attempts,
											row.pro_games_played
										)}
									</td>
									<td className="pl-8 py-3 text-left">
										{safeDivideHelper(
											row.pro_rushing_yards,
											row.pro_games_played
										)}
									</td>
									<td className="pl-8 py-3 text-left">
										{safeDivideHelper(
											row.pro_rushing_touchdowns,
											row.pro_games_played
										)}
									</td>
									<td className="pl-8 py-3 text-left">
										{safeDivideHelper(
											row.pro_rush_attempts,
											row.pro_rushing_touchdowns
										)}
									</td>
									<td className="pl-8 py-3 text-left">
										{safeDivideHelper(
											row.pro_rushing_yards,
											row.pro_rushing_touchdowns
										)}
									</td>
								</tr>
							</Fragment>
						);
					}}
				/>
			</div>
		</div>
	);
}
